export default __webpack_public_path__ + "static/media/stopwatch.79497f3a.png";